var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGetroNetwork(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.729 79.7368C107.521 76.1447 105.46 74.1553 105.918 70.1211C106.305 66.6947 106.779 63.3237 105.129 60.1184C102.184 54.5132 95.0077 53.8026 92.5524 60.2053C91.2261 63.6868 91.1235 68.1 90.6577 71.8026C90.5866 72.3158 90.5235 72.829 90.4524 73.3421C89.6835 73.7554 89.0358 74.3622 88.5735 75.1026C84.8077 80.8895 84.0735 88.5947 87.784 94.6342C91.2498 100.255 98.7735 102.529 104.221 98.3842C109.668 94.2395 110.758 85.7605 108.729 79.7368Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23947 50.7474C9.30263 53.7631 9.73684 57.9079 13.1316 58.9974C14.105 59.2298 15.1166 59.254 16.1 59.0684C16.991 58.9939 17.8865 59.1432 18.7053 59.5026C20.5447 60.2289 22.1947 61.1289 24.2316 61.1921C26.2051 61.2296 28.1398 60.6409 29.7579 59.5105C30.3342 59.1237 31.1947 58.3026 31.9605 58.3816C32.7263 58.4605 33.3895 59.171 34.0605 59.4395C38.1579 61.0895 39.9263 56.1237 40.2342 53.0368C40.9289 45.9316 37.0763 38.8974 32.0711 34.0895V34.0342C32.3025 33.4258 32.428 32.7823 32.4421 32.1316C32.5636 31.1997 32.767 30.2804 33.05 29.3842C33.5553 27.9237 34.7947 26.8421 35.6316 25.571C36.4063 24.4531 36.7843 23.1079 36.7053 21.75C36.6801 21.1392 36.518 20.5419 36.2311 20.0022C35.9441 19.4624 35.5396 18.994 35.0474 18.6316C33.8632 17.8421 32.371 17.9526 31.0053 17.9289C28.1868 17.8816 25.1789 17.5658 22.4158 18.2605C21.0979 18.5809 19.8872 19.2417 18.9049 20.1769C17.9226 21.1121 17.2031 22.2889 16.8184 23.5895C16.0289 26.0763 15.6816 29.5184 16.7395 31.9579L16.4 32.171C15.617 32.6867 14.8894 33.2819 14.2289 33.9474C13.0134 35.2287 12.0208 36.7043 11.2921 38.3131C9.51579 42.2289 9.18421 46.5237 9.23947 50.7474Z",
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2788 26.4632C30.2788 26.4632 31.4788 35.1474 27.5235 36.45C24.3656 37.4921 21.1366 34.7605 20.2998 29.2105",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 61.2C15.5 61.2 9.03417 41.55 20.2842 36.4579",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.479 37.8947C34.9843 40.121 39.2237 45.7894 36.8316 60.3079",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3815 49.9658C33.3815 49.9658 34.9604 58.65 24.6972 58.65C21.6025 58.65 19.0683 58.3974 18.1367 48.3868",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7447 31.579C17.7578 30.6038 17.1195 29.3309 16.9283 27.9568C16.7371 26.5827 17.0036 25.1838 17.6868 23.9763C17.0797 23.8064 16.5335 23.4674 16.1118 22.9988C15.6901 22.5302 15.4104 21.9514 15.3053 21.3298C15.2002 20.7082 15.274 20.0696 15.5182 19.4884C15.7623 18.9072 16.1667 18.4074 16.6841 18.0474C20.1263 15.679 21.6657 21.4421 21.6657 21.4421C26.2999 18.0316 30.871 19.1526 30.4684 22.7132C29.9236 27.5763 22.7236 25.5158 22.7236 25.5158C22.5085 26.0934 22.1197 26.5902 21.6108 26.9379C21.1019 27.2857 20.4978 27.4673 19.8815 27.4579",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2445 100.176L85.9287 75.15L110.189 75.2131V96.8131",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.279 73.0737L90.0737 61.8868L106.045 61.9342V73.1605",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M103.921 87.6079H92.1973V91.1447H103.921V87.6079Z",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4815 79.9737H103.921V83.5105H92.1973V79.9737",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1973 98.7711V95.2342H103.921V98.7711",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5947 66.1737H102.532",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5947 69.9079H102.532",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8501 59.3447V56.1079H101.269V59.3447",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M98.063 53.6132V55.3263",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 44.7632V47.2579",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 72.7421V75.2368",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2762 49.2237L69.5156 50.9842",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4842 69.0158L49.7236 70.7763",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7369 60H73.2422",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7579 60H45.2632",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1081 79.2C82.0055 78.8526 79.5107 70.6026 70.8502 63.7105C71.7426 61.3938 71.7711 58.8332 70.9306 56.4972C70.09 54.1611 68.4366 52.2057 66.2727 50.9887C64.1089 49.7716 61.5792 49.3742 59.1463 49.8692C56.7135 50.3642 54.5402 51.7184 53.0239 53.6842C50.3161 51.7878 47.962 49.431 46.0686 46.721C44.6911 44.7903 43.6943 42.6146 43.1318 40.3105C43.1182 40.2335 43.0752 40.1649 43.0118 40.1192C42.9484 40.0735 42.8696 40.0543 42.7923 40.0658L41.2134 40.3342C41.1373 40.3495 41.0698 40.393 41.0244 40.456C40.9791 40.5189 40.9591 40.5967 40.9686 40.6737C41.0476 41.0526 42.4765 48.9474 51.8713 55.5395C51.1949 56.9291 50.8439 58.4545 50.8449 60C50.8528 62.2166 51.5725 64.372 52.8981 66.1485C54.2237 67.925 56.085 69.2286 58.2076 69.8672C60.3302 70.5057 62.6018 70.4454 64.6876 69.6951C66.7733 68.9449 68.5628 67.5443 69.7923 65.7C74.405 69.3993 77.932 74.2765 80.0002 79.8158C80.0201 79.8755 80.0582 79.9274 80.1092 79.9642C80.1602 80.0011 80.2215 80.021 80.2844 80.021H80.3713L81.887 79.571C81.9275 79.5641 81.966 79.5484 81.9998 79.5252C82.0336 79.502 82.062 79.4717 82.083 79.4364C82.104 79.4012 82.1171 79.3618 82.1215 79.3209C82.1258 79.2801 82.1212 79.2389 82.1081 79.2Z",
    fill: "url(#paint0_linear_15428_156574)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1947 68.471C65.8731 68.471 69.6657 64.6784 69.6657 60C69.6657 55.3216 65.8731 51.5289 61.1947 51.5289C56.5162 51.5289 52.7236 55.3216 52.7236 60C52.7236 64.6784 56.5162 68.471 61.1947 68.471Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0498 60L59.813 62.7632L65.3393 57.2368",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15428_156574",
    x1: 40.9844,
    y1: 60.0474,
    x2: 82.1239,
    y2: 60.0474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FF9793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FF8AA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF80B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#FF66D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGetroNetwork);
export default __webpack_public_path__ + "static/media/icon-getro-network.fdeef6340f506633bb1e65bf3727c782.svg";
export { ForwardRef as ReactComponent };